import React from 'react';
import styled from 'styled-components';
import { Clock } from 'lucide-react';
import { useCountdown } from '../../../hooks/useCountdown';

const TimerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: var(--color-policy-orange-alpha20);
  border: 1px solid #fbbf24;
  border-radius: 0.5rem;
  color: #92400e;
  font-size: 0.875rem;
  font-weight: 500;
`;

const TimerIcon = styled.div`
  display: flex;
  align-items: center;
  color: #d97706;
`;

const TimerText = styled.span`
  font-weight: 600;
`;

const TimeValue = styled.span`
  font-family: 'Courier New', monospace;
  font-weight: 700;
  color: #92400e;
`;

interface AutoPublishTimerProps {
  autoPublishDate: string | null;
}

export const AutoPublishTimer: React.FC<AutoPublishTimerProps> = ({
  autoPublishDate,
}) => {
  const { days, hours, minutes, isExpired } = useCountdown(autoPublishDate);

  if (!autoPublishDate || isExpired) {
    return null;
  }

  const formatTimeUnit = (value: number): string => {
    return value.toString().padStart(2, '0');
  };

  const getTimeString = (): string => {
    const parts: string[] = [];
    
    if (days > 0) {
      parts.push(`${days}d`);
    }
    if (hours > 0 || days > 0) {
      parts.push(`${formatTimeUnit(hours)}h`);
    }
    parts.push(`${formatTimeUnit(minutes)}m`);
    
    return parts.join(' ');
  };

  return (
    <TimerContainer>
      <TimerIcon>
        <Clock size={16} />
      </TimerIcon>
      <TimerText>Auto publishing hotel in:</TimerText>
      <TimeValue>{getTimeString()}</TimeValue>
    </TimerContainer>
  );
};
